export const featureFlags = {
  cvVariant: "core", // "core" | "fe"
  experienceDatesMode: "linkedin", // "real" | "linkedin" | "nooverlap"
  showExperienceLocation: false,
  showExperienceOverlapDisclaimer: false,
  showLanguageLevel: false,
  showCoreSkillsSection: false,
};
